module.exports = __webpack_public_path__ + "img/ring_r_e_0_0@2x.6cad40d8.png";